import React from 'react';
import { Activity } from 'new/elements/Activity';

interface ResourceActivityProps {
  data?: any;
  resourceType: string;
}

export const ResourceActivity = (props: ResourceActivityProps) => {
  const { data, resourceType } = props;
  return <Activity resourceId={data.id} resourceType={resourceType} data={data} />;
};

export default ResourceActivity;
